import { createTheme } from '@mui/material/styles';

let base = createTheme();

// A custom theme for this app
const theme = createTheme({
  spacing: 10,
  typography: {
    fontFamily: [
      "Montserrat",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  palette: {
    primary: {
      main: "#FF6A14",
      contrastText: "#fff",
    },
    secondary: {
      main: "#19857b",
    },
    background: {
      default: "#F8F9FA",
    },
    mode: "light" // Replaces 'type' in v5+
  },
  // 'overrides' is deprecated and ignored. Use 'components' instead.
  components: {
    // Style sheet name ⚛️
    MuiButton: {
      styleOverrides: {
        // Name of the slot
        root: {
          borderRadius: 4,
          boxShadow: "none",
          textTransform: "capitalize", // Moved from 'label' for better v5 compatibility
        },
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
          "&.Mui-disabled": { // Correct syntax for disabled state
            boxShadow: "none"
          },
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          height: 3,
          [base.breakpoints.down("md")]: {
            height: 2,
          },
          [base.breakpoints.up("md")]: {
            height: 3,
          },
        },
      },
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          // zIndex is managed by the component, usually no need to override here
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 8,
        },
      },
    },
    MuiSnackbar: {
      styleOverrides: {
        root: {
          zIndex: 9999,
        },
      },
    },
  },
});

// Your shadow modifications remain the same
theme.shadows[10] = "0px 0px 0px 1px #DDE0E5";
theme.shadows[2] = "0px 3px 1px -2px rgba(0,0,0,0.06),0px 2px 2px 0px rgba(0,0,0,0.06),0px 1px 5px 0px rgba(0,0,0,0.06)";
theme.shadows[1] = "0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)";
theme.shadows[6] = "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.06),0px 1px 18px 0px rgba(0,0,0,0.06)";

export default theme;